import React, { useState } from 'react';
import styled from 'styled-components';
import { submitScore, hasUserWonRoulette } from '../utils/firestoreApi';

const FormContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 500px;
  color: white;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  margin: 0px auto;
`;

const FormTitle = styled.h1`
  text-align: center;
  font-size: 2rem;
  margin-bottom: 30px;
  color: white;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
  flex-shrink: 0;
  min-height: 0;
  height: auto;
`;

const FormCard = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 30px;
  backdrop-filter: blur(10px);
  box-shadow: rgba(0, 0, 0, 0.3) 0px 8px 32px;
  width: 100%;
  max-width: 400px;
  margin: 0px auto;

  @media (max-width: 768px) {
    padding: 10px;
    max-width: 95vw;
  }

  @media (max-width: 480px) {
    padding: 8px;
    max-width: 90vw;
    border-radius: 12px;
    min-height: 56vh;
  }
`;

const FormGroup = styled.div`
  margin-bottom: 10px;
  flex-shrink: 0;
  min-height: 0;
  height: auto;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-weight: bold;
  font-size: 1rem;
  color: white;
  flex-shrink: 0;
  min-height: 0;
  height: auto;
`;

const Input = styled.input`
  width: 100%;
  box-sizing: border-box;
  padding: 15px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  font-size: 1rem;
  transition: all 0.3s ease;
  flex-shrink: 0;
  min-height: 0;
  height: auto;
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.6);
  }
  
  &:focus {
    outline: none;
    border-color: #ff3369;
    background: rgba(255, 255, 255, 0.2);
    box-shadow: 0 0 15px rgba(255, 107, 107, 0.3);
  }
  
  &:invalid {
    border-color: #ff3369;
  }
  @media (max-width: 480px) {
    padding: 10px;
    font-size: 0.95rem;
    border-radius: 8px;
  }
`;

const ErrorMessage = styled.div`
  color: #ff3369;
  font-size: 0.9rem;
  margin-top: 5px;
  min-height: 20px;
  flex-shrink: 0;
  min-height: 0;
  height: auto;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: 8px;
  flex-shrink: 0;
  min-height: 0;
  height: auto;
`;

const Button = styled.button`
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 15px 30px;
  border: none;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  
  ${props => props.$primary ? `
    background: var(--primary-gradient);
    color: white;
    box-shadow: 0 4px 15px rgba(255, 107, 107, 0.4);
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(255, 107, 107, 0.6);
    }
    
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
      transform: none;
    }
  ` : `
    background: rgba(255, 255, 255, 0.2);
    color: white;
    border: 2px solid rgba(255, 255, 255, 0.3);
    
    &:hover {
      background: rgba(255, 255, 255, 0.3);
      transform: translateY(-2px);
    }
  `}
  @media (max-width: 480px) {
    padding: 10px 16px;
    font-size: 0.95rem;
    border-radius: 18px;
  }
`;

const GoogleButton = styled.button`
  width: 100%;
  padding: 10px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  font-size: 0.95rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 8px;
  flex-shrink: 0;
  min-height: 0;
  height: auto;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: #4285F4;
  }
`;

const Divider = styled.div`
  display: flex;
  align-items: center;
  margin: 10px 0;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.85rem;
  flex-shrink: 0;
  min-height: 0;
  height: auto;
  
  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: rgba(255, 255, 255, 0.3);
  }
  
  span {
    padding: 0 8px;
  }
`;

const ScoreDisplay = styled.div`
  background: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  padding: 10px 6px;
  margin-bottom: 8px;
  text-align: center;
  flex-shrink: 0;
  min-height: 0;
  h3 {
    margin: 0 0 8px 0;
    color: #FFD700;
    font-size: 1.1rem;
  }
  .score-info {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }
  .score-item {
    text-align: center;
  }
  .score-label {
    font-size: 0.85rem;
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 2px;
  }
  .score-value {
    font-size: 1.2rem;
    font-weight: bold;
    color: white;
  }
`;

function EntryForm({ gameResult, onSubmit, onRetry }) {
  const [formData, setFormData] = useState({
    nickname: '',
    phone: ''
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [privacyAgreed, setPrivacyAgreed] = useState(false);

  const validateNickname = (nickname) => {
    return nickname.length >= 2 && nickname.length <= 20;
  };

  const validatePhone = (phone) => {
    // +로 시작하고 총 10자리 이상인지 확인 (국가번호 포함)
    const numbers = phone.replace(/[^0-9]/g, '');
    // +국가번호 010-123-4567 또는 +국가번호 010-1234-5678 형식 허용
    return phone.startsWith('+') && numbers.length >= 10;
  };

    // 전화번호 하이픈 자동 삽입 (사용자 입력)
  const formatPhone = (value) => {
    // 숫자, +, -, 공백만 허용
    const allowedChars = value.replace(/[^0-9+\-\s]/g, '');
    
    // +로 시작하지 않으면 +를 앞에 추가
    let formattedValue = allowedChars;
    if (!formattedValue.startsWith('+')) {
      formattedValue = '+' + formattedValue;
    }
    
    return formattedValue;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'phone') {
      const formatted = formatPhone(value);
      setFormData(prev => ({
        ...prev,
        [name]: formatted
      }));
      
      if (errors[name]) {
        setErrors(prev => ({ ...prev, [name]: '' }));
      }
      return;
    }
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // 유효성 검사
    const newErrors = {};
    
    if (!formData.nickname) {
      newErrors.nickname = '닉네임을 입력해주세요.';
    } else if (!validateNickname(formData.nickname)) {
      newErrors.nickname = '닉네임은 2~20자 사이로 입력해주세요.';
    }
    
    if (!formData.phone) {
      newErrors.phone = '전화번호를 입력해주세요.';
    } else if (!validatePhone(formData.phone)) {
      newErrors.phone = '올바른 전화번호 형식을 입력해주세요.';
    } 
    
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      // 목업 제출 - 실제로는 서버 API 호출
      //await new Promise(resolve => setTimeout(resolve, 1000));
      
      // testdata - gameResult가 null일 때 사용할 샘플 데이터
      // const sampleGameResult = {
      //   totalScore: 123456789,
      //   totalCombo: 261,
      //   roundResults: [
      //     { score: 41152263, combo: 87 },
      //     { score: 41152263, combo: 87 },
      //     { score: 41152263, combo: 87 }
      //   ]
      // };
      
      // // gameResult가 null이면 샘플 데이터 사용
      // const gameResult = sampleGameResult;
      
      // Firebase에 실제 점수 저장
      await submitScore({
        nickname: formData.nickname,
        phone: formData.phone,
        score: gameResult && gameResult.totalScore,
        maxCombo: gameResult && gameResult.totalCombo,
        roundResult: gameResult && gameResult.roundResults, // roundResult 필드 추가
        privacyAgreed: privacyAgreed,
        gameCollection: 'rhythm_result' // 리듬게임 컬렉션 추가
      });
      
      // 2) 이 사용자가 룰렛 당첨자 목록에 있는지 확인
      const hasWon = await hasUserWonRoulette(formData.phone);

      // 3) onSubmit 콜백에 hasWon을 함께 전달
      const submissionData = {
        ...formData,
        score: gameResult.totalScore || gameResult.score,
        combo: gameResult.totalCombo || gameResult.combo,
        roundResults: gameResult.roundResults || null,
        timestamp: new Date().toISOString(),
        hasWon,       // 룰렛 당첨 여부
        // 본인 정보 추가 (랭킹에서 찾기 위해)
        userNickname: formData.nickname,
        userPhone: formData.phone
      };
      
      onSubmit(submissionData);
    } catch (error) {
      //console.error('제출 중 오류:', error);
      setErrors({ submit: '점수 저장 중 오류가 발생했습니다. 다시 시도해주세요.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleGoogleLogin = () => {
    // Google 로그인 로직 (향후 구현)
    //console.log('Google 로그인 기능은 향후 구현 예정');
  };

  return (
    <FormContainer>
      {/* <FormTitle>🎵 게임 결과 응모</FormTitle> */}
      
      <FormCard>
        <ScoreDisplay>
          <h3>게임 결과</h3>
          <div className="score-info">
            <div className="score-item">
              <div className="score-label">최종 점수</div>
              <div className="score-value">
                {(() => {
                  if (gameResult && gameResult.roundResults && gameResult.roundResults.length === 3) {
                    const total = gameResult.roundResults.reduce((sum, r) => sum + (r.score || 0), 0);
                    return (total ?? 0).toLocaleString();
                  }
                  return ((gameResult && gameResult.score) ?? 0).toLocaleString();
                })()}
              </div>
            </div>
            <div className="score-item">
              <div className="score-label">최대 콤보</div>
              <div className="score-value">
                {(() => {
                  if (gameResult && gameResult.roundResults && gameResult.roundResults.length === 3) {
                    const totalCombo = gameResult.roundResults.reduce((sum, r) => sum + (r.combo || 0), 0);
                    return totalCombo ?? 0;
                  }
                  return (gameResult && gameResult.combo) ?? 0;
                })()}
              </div>
            </div>
          </div>
        </ScoreDisplay>
        
        <form onSubmit={handleSubmit} style={{flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'stretch', minHeight: 0, height: 'auto', boxSizing: 'border-box'}}>
          <FormGroup>
            <Label htmlFor="nickname">닉네임 *</Label>
            <Input
              type="text"
              id="nickname"
              name="nickname"
              value={formData.nickname}
              onChange={handleInputChange}
              placeholder="닉네임을 입력하세요"
              required
              maxLength={20}
            />
            <ErrorMessage>{errors.nickname}</ErrorMessage>
          </FormGroup>
          
          <FormGroup>
            <Label htmlFor="phone">전화번호 *</Label>
            <Input
              type="text"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              placeholder="+82 010-1234-5678"
              required
              inputMode="text"
              autoComplete="tel"
              maxLength={20}
              style={{ fontFamily: 'monospace' }}
            />
            <ErrorMessage>{errors.phone}</ErrorMessage>
          </FormGroup>
          {/* 여기에 정보가 정확하지 않을 경우 경품 증정이 안될 수 있다는 문구 추가 및 개인정보 동의 체크박스 추가 */}
            <div style={{display: 'flex', flexDirection: 'column'}}>
              <div style={{fontSize: '0.7rem', color: '#ff3369', wordBreak: 'keep-all'}}>
                * 개인정보는 경품 응모 및 당첨 확인 용도로만 사용됩니다.
                <br />
                * 에어팟 프로2 리워드 당첨 확률은 랭킹에 따라 가산되며 추첨을 통한 당첨자 발표는 8월 1주차에 공개됩니다.
                <br />
                * 기프티콘 및 에어팟 프로2에 대한 리워드 발송은 8월 2주차부터 순차적으로 진행될 예정입니다.
              </div>
              <div style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
                <input type="checkbox" id="privacy-agreement" style={{width: '16px', height: '30px'}} checked={privacyAgreed} onChange={e => setPrivacyAgreed(e.target.checked)} />
                <label htmlFor="privacy-agreement" style={{fontSize: '0.8rem', color: 'rgba(255, 255, 255, 0.7)'}}>
                  개인정보 수집 및 이용 동의
                </label>
                <a href="/privacy.html" target="_blank" rel="noopener noreferrer" style={{fontSize: '0.8rem', color: '#FFD700', textDecoration: 'underline', marginLeft: '6px'}}>전문 보기</a>
              </div>
            </div>

          <ButtonContainer>
            <Button type="button" onClick={onRetry}>
              다시 시도
            </Button>
            <Button type="submit" $primary disabled={isSubmitting || !privacyAgreed}>
              {isSubmitting ? '제출 중...' : '응모하기'}
            </Button>
          </ButtonContainer>

          <div style={{fontSize: '0.8rem', color: 'rgba(255, 255, 255, 0.7)', marginTop: '10px'}}>
            * 응모 후 룰렛을 통해 기프티콘 추첨을 확인해보세요!
          </div>
          {errors.submit && <ErrorMessage>{errors.submit}</ErrorMessage>}
        </form>
        
        {/* <Divider>
          <span>또는</span>
        </Divider>
        
        <GoogleButton onClick={handleGoogleLogin}>
          🔐 Google 계정으로 응모하기
        </GoogleButton> */}
      </FormCard>
    </FormContainer>
  );
}

export default EntryForm; 